// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "reactPlayerPreview" + "." + "1dfaf041e1bd561a" + ".js";
};